/**
 * Компонент Swiper слайдера для секции «Крипто».
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class CryptoSwiper {
    /**
     * Инициализирует слайдер, если секция есть на странице.
     */
    constructor() {
        const swiperEl = document.querySelector('.section-home-crypto__swiper');

        if (!swiperEl) {
            return;
        }

        return new Swiper(swiperEl, this.getDefaultConfig());
    }

    /**
     * @returns {Object}
     */
    getDefaultConfig() {
        return {
            modules: [Navigation],
            slidesPerView: 1.1,
            spaceBetween: 8,
            loop: true,
            navigation: {
                nextEl: '.section-home-crypto__swiper-button-next',
                prevEl: '.section-home-crypto__swiper-button-prev',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 8,
                },
            },
        };
    }
}

export default CryptoSwiper;
